"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearSameWindowLocalStorage = exports.removeChatStartTime = exports.setChatStartTime = exports.getChatStartTime = exports.removeCachedHasInformedAgentOfPopOut = exports.setCachedHasInformedAgentOfPopOut = exports.getCachedHasInformedAgentOfPopOut = exports.removeCachedHasInformedAgentOfInline = exports.setCachedHasInformedAgentOfInline = exports.getCachedHasInformedAgentOfInline = exports.removeCachedClientContext = exports.setCachedClientContext = exports.getCachedClientContext = exports.removeCachedInlineChatMinimised = exports.setCachedInlineChatMinimised = exports.getCachedInlineChatMinimised = void 0;
const local_storage_methods_1 = require("./local-storage.methods");
const local_storage_config_1 = __importDefault(require("./local-storage.config"));
// ----------------------------------------
// Iframe minimised state
_a = (0, local_storage_methods_1.generateGetSetRemove)({
  key: local_storage_config_1.default.SAME_WINDOW.INLINE_CHAT_MINIMISED_STATE
}), exports.getCachedInlineChatMinimised = _a[0], exports.setCachedInlineChatMinimised = _a[1], exports.removeCachedInlineChatMinimised = _a[2];
// ----------------------------------------
// Client context
_b = (0, local_storage_methods_1.generateGetSetRemove)({
  key: local_storage_config_1.default.SAME_WINDOW.CLIENT_CONTEXT
}), exports.getCachedClientContext = _b[0], exports.setCachedClientContext = _b[1], exports.removeCachedClientContext = _b[2];
// ----------------------------------------
// "Has informed agent" messages
_c = (0, local_storage_methods_1.generateGetSetRemove)({
  key: local_storage_config_1.default.SAME_WINDOW.HAS_INFORMED_AGENT_OF_INLINE
}), exports.getCachedHasInformedAgentOfInline = _c[0], exports.setCachedHasInformedAgentOfInline = _c[1], exports.removeCachedHasInformedAgentOfInline = _c[2];
_d = (0, local_storage_methods_1.generateGetSetRemove)({
  key: local_storage_config_1.default.SAME_WINDOW.HAS_INFORMED_AGENT_OF_POPOUT
}), exports.getCachedHasInformedAgentOfPopOut = _d[0], exports.setCachedHasInformedAgentOfPopOut = _d[1], exports.removeCachedHasInformedAgentOfPopOut = _d[2];
_e = (0, local_storage_methods_1.generateGetSetRemove)({
  key: local_storage_config_1.default.SAME_WINDOW.CHAT_START_TIME
}), exports.getChatStartTime = _e[0], exports.setChatStartTime = _e[1], exports.removeChatStartTime = _e[2];
// ----------------------------------------
// Clear cache
/**
 * Clear all same-window cached values in `localStorage`.
 */
const clearSameWindowLocalStorage = () => {
  (0, exports.removeCachedInlineChatMinimised)();
  (0, exports.removeCachedClientContext)();
  (0, exports.removeCachedHasInformedAgentOfInline)();
  (0, exports.removeCachedHasInformedAgentOfPopOut)();
  (0, exports.removeChatStartTime)();
};
exports.clearSameWindowLocalStorage = clearSameWindowLocalStorage;